export const moduleCategories = {
  "Core HR Modules": [
    { key: "employeeManagement", label: "Employee Management" },
    { key: "attendanceManagement", label: "Attendance Management" },
    { key: "leaveManagement", label: "Leave Management" },
  ],
  "Payroll Modules": [
    { key: "payrollManagement", label: "Payroll Management" },
    { key: "advancementRequests", label: "Advancement Requests" },
    { key: "salarySlips", label: "Salary Slips" },
  ],
  "Document Modules": [
    { key: "documentRequests", label: "Document Requests" },
    { key: "documentGeneration", label: "Document Generation" },
    { key: "employeeDocuments", label: "Employee Documents" },
  ],
  "Communication Modules": [
    { key: "communicatorModule", label: "Communicator Module (PTT & Private Messages)" },
    { key: "pttChannels", label: "PTT Channels" },
    { key: "privateMessaging", label: "Private Messaging" },
  ],
  "Calendar & Events": [
    { key: "calendarModule", label: "Calendar Module" },
    { key: "eventManagement", label: "Event Management" },
  ],
  "Employee Actions": [
    { key: "employeeActions", label: "Employee Actions" },
    { key: "promotions", label: "Promotions" },
    { key: "transfers", label: "Transfers" },
    { key: "terminations", label: "Terminations" },
  ],
  "Reports & Analytics": [
    { key: "attendanceReports", label: "Attendance Reports" },
    { key: "payrollReports", label: "Payroll Reports" },
    { key: "leaveReports", label: "Leave Reports" },
    { key: "customReports", label: "Custom Reports" },
  ],
  "Advanced Features": [
    { key: "biometricIntegration", label: "Biometric Integration" },
    { key: "apiAccess", label: "API Access" },
    { key: "bulkOperations", label: "Bulk Operations" },
    { key: "dataExport", label: "Data Export" },
    { key: "dataImport", label: "Data Import" },
  ],
  "Admin Features": [
    { key: "userManagement", label: "User Management" },
    { key: "roleManagement", label: "Role Management" },
    { key: "systemSettings", label: "System Settings" },
    { key: "auditLogs", label: "Audit Logs" },
  ],
};